import { Signal, TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  crudActions,
  DatasetTableConfig,
  TableConfigBuilder,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { DatabaseTagsModel } from '@models/database-tags.model';

export type TagCellContext = CellTemplateContext<DatabaseTagsModel.DatabaseTagDocument>;

export interface CreateTagsTableConfigDependencies {
  nameCellTemplate: TemplateRef<TagCellContext>;
  isShownInLeftPanelCellTemplate: TemplateRef<TagCellContext>;
  defaultTagColor: string;
  onRowClick: (row: DatabaseTagsModel.DatabaseTagDocument) => void;
}

export function createTagsTableConfig(
  dependencies: CreateTagsTableConfigDependencies,
): DatasetTableConfig<DatabaseTagsModel.DatabaseTagDocument> {
  const builder = new ColumnBuilder<DatabaseTagsModel.DatabaseTagDocument>();

  return new TableConfigBuilder<DatabaseTagsModel.DatabaseTagDocument>()
    .columns([
      builder
        .column('name')
        .label('DATABASE_TAGS.TABLE_NAME')
        .width('minmax(150px, 1fr)')
        .cellTemplate(dependencies.nameCellTemplate)
        .mobileVisible()
        .build(),

      builder
        .column('isShownInLeftPanel')
        .width('minmax(150px, 1fr)')
        .cellTemplate(dependencies.isShownInLeftPanelCellTemplate)
        .mobileVisible()
        .alignCenter()
        .headerWithTooltip('NAVIGATION_TREE.SHOW_IN_LEFT_PANEL', 'NAVIGATION_TREE.SHOW_IN_LEFT_PANEL_DESC')
        .build(),
    ])
    .actions(crudActions<DatabaseTagsModel.DatabaseTagDocument>())
    .trackBy('_id')
    .onRowClick(dependencies.onRowClick)
    .build();
}
